/** Badge IDs stored in student progress; definitions for display. */

export const BADGE_DEFINITIONS: Record<string, { label: string; description: string }> = {
  first_victory: { label: 'First Victory', description: 'Defeated your first boss!' },
  mastered_3: { label: 'Triple Threat', description: 'Mastered 3 bosses' },
  strand_History: { label: 'History Explorer', description: 'Mastered a History boss' },
  strand_Geography: { label: 'Geography Scout', description: 'Mastered a Geography boss' },
  strand_Civics: { label: 'Civics Citizen', description: 'Mastered a Civics & Government boss' },
  strand_Economics: { label: 'Economics Ace', description: 'Mastered an Economics boss' },
  // Realm-completion badges — awarded for clearing an entire strand (every node
  // proficient-or-mastered), not just one boss. Status/collection reward.
  realm_History: { label: 'History Champion', description: 'Cleared the entire History realm!' },
  realm_Geography: { label: 'Geography Champion', description: 'Cleared the entire Geography realm!' },
  realm_Civics: { label: 'Civics Champion', description: 'Cleared the entire Civics & Government realm!' },
  realm_Economics: { label: 'Economics Champion', description: 'Cleared the entire Economics realm!' },
  realm_all: { label: 'Super Civica Champion', description: 'Cleared all four realms — a true master!' },
}

export function getBadgeLabel(id: string): string {
  return BADGE_DEFINITIONS[id]?.label ?? id
}

export function getBadgeDescription(id: string): string {
  return BADGE_DEFINITIONS[id]?.description ?? ''
}
